import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'

import { breakpoint, zIndex } from '@twistopayments/design-system/styles'

export const positions = {
  absolute: css`
    position: absolute;
  `,
  relative: css`
    position: relative;
    top: unset;
    right: unset;

    ${breakpoint.up('sm')} {
      top: unset;
      right: unset;
    }
  `,
}

export const root = (theme: Theme) => css`
  top: ${theme.spacing[16]};
  right: ${theme.spacing[24]};
  z-index: ${zIndex.tooltip};
  overflow: hidden;
  padding: ${theme.spacing[4]};

  ${breakpoint.up('sm')} {
    top: ${theme.spacing[24]};
    right: ${theme.spacing[32]};
    padding: ${theme.spacing[8]};
  }
`
